import type { Diet, Localized } from "../api/types";
import raw from "./menu.json";

/**
 * The bundled menu — the seed, and the fallback when the API is unreachable.
 * The live copy lives in the database and is edited from /dashboard; the
 * server seeds it from this same JSON file the first time it starts.
 */

export interface RawOption {
  id: number;
  name: Localized;
  price: string;
  is_default: boolean;
  is_removable: boolean;
}

export interface RawGroup {
  id: number;
  name: Localized;
  selection_type: "single" | "multi";
  min_select: number;
  max_select: number;
  is_required: boolean;
  options: RawOption[];
}

export interface RawItem {
  id: number;
  slug: string;
  name: Localized;
  description: Localized;
  price: string;
  image: string | null;
  diet: Diet | null;
  is_seasonal?: boolean;
  is_favourite?: boolean;
  allergens: Localized;
  max_per_order?: number;
  is_available?: boolean;
  modifier_groups?: RawGroup[];
}

export interface RawCategory {
  id: number;
  slug: string;
  name: Localized;
  description: Localized;
  daypart: "morning" | "afternoon" | "evening" | "all";
  items: RawItem[];
}

export const MENU: RawCategory[] = (raw as { categories: RawCategory[] }).categories;
